// extracted by mini-css-extract-plugin
module.exports = {"upload":"FileUpload_upload__2EpRU"};